// extracted by mini-css-extract-plugin
export default {"melodyVideo":"UJ-z","isFullWidth":"VJ-z","landingPageVideo":"WJ-z","play":"XJ-z","iframeVideo":"YJ-z","playHidden":"ZJ-z","fullwidth":"_J-z"};